import React from 'react'
import "./One_course.scss"

function One_course() {
  return (
    <div>One_course</div>
  )
}

export default One_course